<template>
  <div
    class="distributor-search-result-single"
    :class="{'focussed': distributorSelected}"
    @click="$emit('focusOnDistributor')"
  >
    <div class="details">
      <h3 class="h5">
        {{ distributor.Name }}
      </h3>
      <div class="address">
        {{ distributor.Street }} | {{ distributor.ZIP }}
        {{ distributor.City }} | {{ distributor.Country }}
      </div>
      <div>
        {{ distributor.Phone }}
      </div>
    </div>
    <div class="links">
      <a
        :href="'mailto:' + distributor.EMail"
        v-if="distributor.EMail"
      ><CommunicationEmail
        class="icon email"
        :title="$tv('emailIconTooltip', 'distributorSearch')"
      /></a>
      <a
        :href="sanitizeUrl(distributor.WebsiteURL)"
        v-if="distributor.WebsiteURL"
        target="_blank"
      ><SocialPublic
        class="icon globe"
        :title="$tv('globeIconTooltip', 'distributorSearch')"
      /></a>
    </div>
  </div>
</template>

<script>
import CommunicationEmail from '~/assets/icons/communication_email.svg?component'
import SocialPublic from '~/assets/icons/social_public.svg?component'

export default {
  name: 'DistributorSearchResultSingle',
  components: {CommunicationEmail, SocialPublic},
  props: {
    distributor: {
      type: Object,
      required: true
    },
    distributorSelected: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  methods: {
    sanitizeUrl(url) {
      if (/^http(s?):\/\//i.test(url)) {
        return url
      } else {
        return 'http://' + url
      }
    }
  }
}
</script>

<style lang="scss">
.distributor-search-result-single {
  cursor: pointer;
  padding: 0 .75rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &.focussed {
    background-color: $color--distributor__selected;
  }

  .links {
    max-width: 3rem;
    margin-right: .5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    a {
      &:hover {
        text-decoration: none;
      }
    }
  }

  .icon {
    font-size: 1.3125rem;

    &.globe {
      color: $color__default;
    }

    &.email {
      color: $color__primary;
    }
  }

  h3 {
    font-size: .938rem;
    font-weight: $base-text-font-weight-bold;
    margin: 0 0 .8rem;
  }

  .details {
    padding: .75rem 0;

    div {
      font-weight: lighter;
    }
  }

  .address {
    margin: 0 0 .8rem;
  }
}
</style>
